import { isPromo } from "../utils/utils"

interface LoadedParams {
  sendAllProductData: boolean
  isPromo: boolean
  requiredProductIds: string[]
}

function replaceAll(str: string, search: string, replacement: string): string {
  if (search === "") {
    // avoid infinite loop
    return str
  }

  // Escape special characters for use in a RegExp
  const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  const regex = new RegExp(escapedSearch, "g")
  return str.replace(regex, replacement)
}

export function getCurrentPageLoadedParams(): LoadedParams {
  const path = replaceAll(window.location.pathname, "/", "")

  if (
    path == "limitedtimepaywall" ||
    path == "taPaywall" ||
    path == "emailPromo"
  ) {
    return {
      sendAllProductData: false,
      isPromo: false,
      requiredProductIds: ["promo_yearly"],
    }
  }

  if (isPromo()) {
    return { sendAllProductData: false, isPromo: true, requiredProductIds: [] }
  }

  return { sendAllProductData: false, isPromo: false, requiredProductIds: [] }
}
